export default __webpack_public_path__ + "static/media/ai-white.d8374b48.svg";